import { CustomProgressToast as CustomProgressToastComponent } from "./CustomProgressToast";
import { toastCustomProgressEmitter } from "./toastCustomProgressEmitter";
import {
  ToastProvider as ToastProviderComponent,
  useToast as useToastHook,
} from "./ToastProvider";

export const ToastProvider = ToastProviderComponent;
export const useToast = useToastHook;

export const customProgressEmitter = toastCustomProgressEmitter;
export const CustomProgressToast = CustomProgressToastComponent;
